import c from 'classnames';

import { Stack, Typography } from '@lyearn/ui';

import { DialogEntityContainerProps, DialogEntityProps } from './types';

export const DialogEntityContainer = (props: DialogEntityContainerProps) => {
  const { children } = props;

  return <Stack className="mt-20 rounded border border-border px-12 py-[1.1rem]">{children}</Stack>;
};

const DialogEntity = (props: DialogEntityProps) => {
  const {
    className = 'mt-20',
    image,
    title,
    titleNode: titleNodeProp,
    description,
    descriptionNode: descriptionNodeProp,
  } = props;

  const titleNode = titleNodeProp || (
    <Typography className="truncate" color="text-text-primary" variant="label-02">
      {title}
    </Typography>
  );

  const descriptionNode = descriptionNodeProp || (
    <Typography className="truncate" color="text-text-secondary" variant="body-short-02">
      {description}
    </Typography>
  );

  return (
    <Stack className={c('rounded border border-border px-12 py-[1.1rem]', className)} gapX={12}>
      {image}
      <Stack className="min-w-0" direction="col" gapY={2}>
        {titleNode}
        {descriptionNode}
      </Stack>
    </Stack>
  );
};

export default DialogEntity;
